import React from "react";
import logoschool from "../../assets/images/logosignup.png";
import logomain from "../../assets/images/logomain.png";
import googleIcon from "../../assets/images/google.png";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";
import TrialExpiredModal from "../../components/TrialExpiredModal";
import { verifySchoolSubscriptionBlocked } from "../../utils/schoolSubscription";
import { useTrialExpiredModal } from "../../hooks/useTrialExpiredModal";

const CreateSignup = () => {
	const navigate = useNavigate()
	const { signupData, setSignupData } = React.useContext(SchoolSignupContext);
	const [errorMessage, setErrorMessage] = useState("");
		const [schoolType] = useState(signupData?.schoolType ? signupData?.schoolType : "");
const GOOGLE_AUTH_URL = process.env.REACT_APP_GOOGLE_AUTH_URL;


	const [email, setEmail] = useState(signupData?.email || "")
	const {
		showTrialExpiredModal,
		setShowTrialExpiredModal,
		handleTrialRenew,
		handleTrialCancel,
		cancelLoading,
	} = useTrialExpiredModal(signupData);

	const baseURL = process.env.REACT_APP_BASE_URL;

	const blockIfTrialExpired = async () => {
		const blocked = await verifySchoolSubscriptionBlocked(baseURL, {
			...signupData,
			schoolCode: signupData.schoolCode ?? signupData.verificationCode,
		});
		if (blocked) {
			setShowTrialExpiredModal(true);
			return true;
		}
		return false;
	};

	useEffect(() => {

		setSignupData((prev) => ({
			...prev,
			email: email,
		}));


	}, [email, setSignupData])

	const handleGoogleLogin = async () => {
		if (await blockIfTrialExpired()) return;
		window.location.href = GOOGLE_AUTH_URL;
		// window.location.href = "https://scsbcbacknew.makemagento.com/auth/login";
		// window.location.href = "http://localhost:8000/auth/login";
		// window.location.href = "http://localhost:8000";

		// http://localhost:8000/auth/login

	};

	const handleEmailContinue = async () => {
		if (await blockIfTrialExpired()) return;

		if (!email) {
			setErrorMessage("Please enter your email.");
			return;
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!emailRegex.test(email)) {
			setErrorMessage("Please enter a valid email address.");
			return;
		}

		navigate("/signupaccount", { state: { email } });
	};

	return (<>
		<TrialExpiredModal
			open={showTrialExpiredModal}
			onActivatePlan={handleTrialRenew}
			onCancelSubscription={handleTrialCancel}
			cancelLoading={cancelLoading}
		/>
		<div className="school-pages-inner">
			<div className="school-content-page">
				{/* <img src={logoschool}/> */}
				{schoolType === 1 ? <img src={logomain}
					alt="School Logo"
					style={{ cursor: "pointer" }}
					onClick={() => navigate("/school")}
				/> :
				<img
					src={logoschool}
					alt="School Logo"
					style={{ cursor: "pointer" }}
					onClick={() => navigate("/school")}
				/>}

				<div className="schoo-outer">
					<div className="signup-outer-pagess">
						<h2>Create an Account</h2>
						<div className="email-inner" >

							<div className="input-container">
								<input type="email"
									value={email}
									onChange={(e) => setEmail(e.target.value.toLowerCase())}
									placeholder=" "
								/>
								<label >Email address*</label>

							</div>
							{errorMessage && <p className="error-message" style={{ color: "red" }}>{errorMessage}</p>}



							<button className="continue-btn"
								onClick={handleEmailContinue}
							//   onClick={() => navigate("/signupaccount", { state: { email } })}
							>

								Continue
							</button>
						</div>


						<p className="login-account" >
							Already have an account ?
							<a
								href="/login-page"
								//   href="/login-page"
								onClick={(e) => {
									e.preventDefault(); // Prevent full page reload
									navigate("/login-page"); // Use client-side navigation
								}}
								style={{ cursor: 'pointer' }}


							>
								Login
							</a>
						</p>

						<div className="or-inner" >
							<hr />
							<span >OR</span>
							<hr />
						</div>

						<div className="continue-inner-page">

							<button className="google-continue" onClick={handleGoogleLogin}>
								<img
									//  src="/google.png"
									src={googleIcon}

									//   src="https://auth.openai.com/assets/google-logo-NePEveMl.svg" 
									alt="Google" />
								<span className="left-span">
									Continue with Google</span>
							</button>


						</div>

						<p className="term-part" >
							<a href="/terms-of-use" >Terms of Use</a>  |  <a href="/privacy-policy" >Privacy Policy</a>
						</p>





					</div>

				</div>

			</div>

		</div>



	</>);

}
export default CreateSignup;